<div class="container-fluid">
  <h4 id="upper">Transactions demande de Location</h4>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-body">
          <!-- Barre de filtres -->
          <div class="row mb-3">
            <div class="col-md-12">
              <div class="d-flex align-items-center gap-3 flex-wrap">
                <!-- Recherche -->
                <div class="flex-grow-1" style="min-width: 200px;">
                  <label class="form-label mb-0">Rechercher</label>
                  <div class="input-group">
                    <span class="input-group-text"><i class="mdi mdi-magnify"></i></span>
                    <input title="Rechercher par référence, membre, téléphone ou machine" type="text"
                      [(ngModel)]="searchTerm" (input)="filterBySearchTerm()" class="form-control" id="searchMembre"
                      placeholder="Rechercher..." />
                    <button class="btn btn-outline-secondary" (click)="searchTerm = ''; filterBySearchTerm()"
                      type="button" *ngIf="searchTerm">
                      <i class="mdi mdi-close"></i>
                    </button>
                  </div>
                </div>

                <!-- Filtre par statut de paiement -->
                <div style="min-width: 180px;">
                  <label class="form-label mb-0">Statut paiement</label>
                  <select class="form-select" [(ngModel)]="selectedStatus" (change)="onStatusChange()">
                    <option *ngFor="let option of statusOptions" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <!-- Filtre par statut de location -->
                <div style="min-width: 180px;">
                  <label class="form-label mb-0">Statut location</label>
                  <select class="form-select" [(ngModel)]="selectedLocationStatus" (change)="onLocationStatusChange()">
                    <option *ngFor="let option of locationStatusOptions" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <!-- Filtre par mode de paiement -->
                <div style="min-width: 180px;">
                  <label class="form-label mb-0">Mode paiement</label>
                  <select class="form-select" [(ngModel)]="selectedPaymentMethod" (change)="onPaymentMethodChange()">
                    <option *ngFor="let option of paymentMethodOptions" [value]="option.value">
                      {{ option.label }}
                    </option>
                  </select>
                </div>

                <!-- Filtre par date -->
                <div style="min-width: 170px;">
                  <label class="form-label mb-0">Date début</label>
                  <input type="date" class="form-control" [(ngModel)]="dateDebut" (change)="applyFilters()" />
                </div>
                <div style="min-width: 170px;">
                  <label class="form-label mb-0">Date fin</label>
                  <input type="date" class="form-control" [(ngModel)]="dateFin" (change)="applyFilters()" />
                </div>

                <!-- Statistiques rapides -->
                <div class="d-flex gap-2 flex-wrap" style="margin-top: 22px;">
                  <span class="badge bg-secondary p-2">
                    <i class="mdi mdi-cart"></i>
                    Total: {{ items.length }}
                  </span>
                  <span class="badge bg-success p-2">
                    <i class="mdi mdi-check-circle"></i>
                    Payés: {{ getStatusCount('paid') }}
                  </span>
                  <span class="badge bg-danger p-2">
                    <i class="mdi mdi-close-circle"></i>
                    Échoués: {{ getStatusCount('failed') }}
                  </span>
                  <span class="badge bg-warning p-2">
                    <i class="mdi mdi-clock"></i>
                    En attente: {{ getStatusCount('pending') }}
                  </span>
                  <span class="badge bg-primary p-2">
                    <i class="mdi mdi-check"></i>
                    Approuvés: {{ getLocationStatusCount('approved') }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <!-- Tableau -->
          <div class="table-responsive">
            <table class="table text-nowrap align-middle mb-0">
              <thead>
                <tr class="border-2 border-bottom border-primary border-0 custom-border-bottom-medecin"
                  style="border-color: #578D63;">
                  <th scope="col">Référence</th>
                  <th scope="col">Membre</th>
                  <th scope="col">Téléphone</th>
                  <th scope="col">Machine</th>
                  <th scope="col">Montant</th>
                  <th scope="col">Paiement</th>
                  <th scope="col">Location</th>
                  <th scope="col">Date</th>
                  <th scope="col" class="text-center">Action</th>
                </tr>
              </thead>
              <tbody class="table-group-divider">
                <tr *ngFor="let item of paginatedItems">
                  <td>
                    <span class="table-link1 text-truncate d-block" title="{{ item?.reference }}" style="max-width: 120px;">
                      {{ item?.reference | slice:0:8 }}...
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block">
                      {{ item?.membre?.prenom || '' }} {{ item?.membre?.nom }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block">
                      {{ item?.telephone || '-' }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block" title="{{ item?.location?.machine?.nom }}" style="max-width: 150px;">
                      {{ item?.location?.machine?.nom }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block fw-bold">
                      {{ item?.montant }} FCFA
                    </span>
                  </td>
                  <td>
                    <span class="badge {{ getStatusBadge(item?.statut) }}" style="font-size: 11px; padding: 5px 10px;">
                      <i class="mdi" [class.mdi-check-circle]="item?.statut === 'paid'"
                        [class.mdi-close-circle]="item?.statut === 'failed'"
                        [class.mdi-clock]="item?.statut === 'pending'"
                        [class.mdi-cancel]="item?.statut === 'cancelled'"
                        me-1>
                      </i>
                      {{ getStatusLabel(item?.statut) }}
                    </span>
                  </td>
                  <td>
                    <span class="badge {{ getLocationStatusBadge(item?.location?.status) }}" style="font-size: 11px; padding: 5px 10px;">
                      <i class="mdi" [class.mdi-check]="item?.location?.status === 'approved'"
                        [class.mdi-close]="item?.location?.status === 'rejected'"
                        [class.mdi-clock]="item?.location?.status === 'pending'"
                        [class.mdi-check-all]="item?.location?.status === 'completed'"
                        me-1>
                      </i>
                      {{ getLocationStatusLabel(item?.location?.status) }}
                    </span>
                  </td>
                  <td>
                    <span class="table-link1 text-truncate d-block" style="font-size: 11px;">
                      {{ formatDateShort(item?.created_at) }}
                    </span>
                  </td>
                  <td class="text-center">
                    <a (click)="openDetailModal(item)" style="cursor: pointer;" class="me-2 text-info" v-b-tooltip.hover
                      title="Voir les détails">
                      <i class="mdi mdi-eye font-size-18"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Message si aucun résultat -->
          <div *ngIf="paginatedItems.length === 0 && !isLoading" class="text-center py-4">
            <i class="mdi mdi-inbox-outline" style="font-size: 48px; color: #ccc;"></i>
            <h5 class="text-muted">Aucune demande de location trouvée</h5>
            <p class="text-muted" *ngIf="selectedStatus || selectedLocationStatus || selectedPaymentMethod || searchTerm || dateDebut || dateFin">
              Aucun résultat ne correspond à vos critères de recherche.
              <a (click)="resetFilters()" style="cursor: pointer; color: #578D63;">
                Réinitialiser les filtres
              </a>
            </p>
          </div>

          <!-- Chargement -->
          <div class="d-flex justify-content-center" *ngIf="isLoading === true">
            <div class="container">
              <div class="row">
                <div class="text-center">
                  <h5 id="graycolor">Chargement en cours...</h5>
                  <div class="loader4"></div>
                </div>
              </div>
            </div>
          </div>

          <!-- Pagination -->
          <p-paginator (onPageChange)="onPageChange($event)" [first]="first" [rows]="rows" [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[10, 20, 30]">
          </p-paginator>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Détails -->
<ng-template #detailModal let-modal>
  <div class="modal-header" style="background-color: #578D63; color: white;">
    <h5 class="modal-title text-white">
      <i class="mdi mdi-receipt-text me-2"></i>
      Détails de la demande de location
    </h5>
    <button type="button" class="btn-close btn-close-white" (click)="modal.dismiss('Cross click')"></button>
  </div>
  <div class="modal-body" *ngIf="selectedItem">
    <!-- En-tête de la transaction -->
    <div class="row mb-4">
      <div class="col-md-6">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">Informations générales</h6>
            <p class="mb-1"><strong>Référence :</strong> {{ selectedItem.reference }}</p>
            <p class="mb-1"><strong>Transaction ID :</strong> {{ selectedItem.transaction_id || 'Non disponible' }}</p>
            <p class="mb-1"><strong>Montant :</strong> <span class="fw-bold text-success">{{ selectedItem.montant }} FCFA</span></p>
            <p class="mb-1">
              <strong>Statut paiement :</strong>
              <span class="badge {{ getStatusBadge(selectedItem.statut) }}">
                {{ getStatusLabel(selectedItem.statut) }}
              </span>
            </p>
            <p class="mb-1">
              <strong>Mode de paiement :</strong>
              <i class="{{ getPaymentMethodIcon(selectedItem.mode_paiement) }} me-1"></i>
              {{ getPaymentMethodLabel(selectedItem.mode_paiement) }}
            </p>
            <p class="mb-0"><strong>Téléphone :</strong> {{ selectedItem.telephone || 'Non spécifié' }}</p>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card bg-light">
          <div class="card-body">
            <h6 class="card-subtitle mb-2 text-muted">Informations membre</h6>
            <p class="mb-1"><strong>Nom :</strong> {{ selectedItem.membre?.prenom || '' }} {{ selectedItem.membre?.nom }}</p>
            <p class="mb-1"><strong>Référence :</strong> {{ selectedItem.membre?.reference || 'Non spécifié' }}</p>
            <p class="mb-0"><strong>Date de création :</strong> {{ formatDate(selectedItem.created_at) }}</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Détails de la location -->
    <div class="card mb-4" *ngIf="selectedItem.location">
      <div class="card-header bg-primary text-white">
        <h6 class="mb-0"><i class="mdi mdi-calendar me-2"></i>Détails de la location</h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <p class="mb-1"><strong>Machine :</strong> {{ selectedItem.location.machine?.nom || 'Non spécifiée' }}</p>
            <p class="mb-1"><strong>Référence machine :</strong> {{ selectedItem.location.machine?.reference || 'Non spécifiée' }}</p>
            <p class="mb-1"><strong>Quantité :</strong> {{ selectedItem.location.quantite || 1 }}</p>
          </div>
          <div class="col-md-6">
            <p class="mb-1"><strong>Date début :</strong> {{ formatDate(selectedItem.location.date_debut) }}</p>
            <p class="mb-1"><strong>Date fin :</strong> {{ formatDate(selectedItem.location.date_fin) }}</p>
            <p class="mb-1">
              <strong>Durée :</strong> 
              <span class="badge bg-info">
                {{ getLocationDays(selectedItem) }} jour(s)
              </span>
            </p>
            <p class="mb-0">
              <strong>Statut location :</strong>
              <span class="badge {{ getLocationStatusBadge(selectedItem.location.status) }}">
                {{ getLocationStatusLabel(selectedItem.location.status) }}
              </span>
            </p>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12">
            <p class="mb-0"><strong>Montant total :</strong> <span class="fw-bold text-success">{{ selectedItem.location.montant_total }} FCFA</span></p>
          </div>
        </div>
      </div>
    </div>

    <!-- Dates d'opération -->
    <div class="card">
      <div class="card-header bg-secondary text-white">
        <h6 class="mb-0"><i class="mdi mdi-clock me-2"></i>Dates importantes</h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-6">
            <p class="mb-1"><strong>Date d'opération :</strong> {{ formatDate(selectedItem.date_operation) }}</p>
          </div>
          <div class="col-md-6">
            <p class="mb-0"><strong>Date de création :</strong> {{ formatDate(selectedItem.created_at) }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">
      <i class="mdi mdi-close me-1"></i> Fermer
    </button>
    <button type="button" class="btn btn-primary" (click)="modal.close('Close click')">
      <i class="mdi mdi-check me-1"></i> OK
    </button>
  </div>
</ng-template>

<p-toast />
<p-confirmDialog />
<ngx-ui-loader></ngx-ui-loader>